




























helpers = require '../../helpers.coffee'

view_model = {
  components:
    sendAtPicker: require './picker/send_at'
    typePicker: require './picker/type'

  data: ->
    actions: []
    current_step: 0
    flow: new Flow
    templates: []
    template_categories: []
    template_variables: []

  computed:
    options: ->
      allow_create: true
      allow_blank: @flow.semi_automatic
      from_flow: true
      disabled: @flow.isWithError()
      preload:
        variables: @template_variables
        categories: @template_categories

  methods:
    addAction: (attributes={}) ->
      attributes.type = if @flow.semi_automatic then 'TaskFlowAction' else 'EmailFlowAction'
      attributes.manual_task_parameters = { service: Task.emailTaskService.service } if @flow.semi_automatic
      attributes.step = @current_step
      attributes.delay_after_previous_step_amount ?= 2
      attributes.send_immediately = attributes.immediately
      @actions.push new FlowAction(attributes)
      @current_step += 1

    removeAction: (action_index) ->
      action = @actions[action_index]

      if action.isPersisted()
        if action._destroy
          action._destroy = false
        else
          action._destroy = true
      else
        @actions.splice action_index, 1

    setActionType: (data) ->
      action = @actions[data.reference]
      action.type = data.type
      action.send_as_reply = data.send_as_reply

      if data.template? && data.template.id > 0
        action.template_id = data.template.id
        template = @getTemplate(data.template.id)
        action.template = template unless !template
      else
        action.template_id = null
        action.template = data.template || {}

      if data.manual_task_parameters
        action.manual_task_parameters = data.manual_task_parameters
      else
        action.manual_task_parameters = null

      @flow.toggleActionTypes()

    setActionSendAt: (data) ->
      action = @actions[data.reference]
      action.send_at_kind = data.send_at_kind
      action.send_at = @buildSendAt data.send_at
      action.delay_after_previous_step_amount = data.delay_after_previous_step_amount
      action.delay_after_previous_step_unit = data.delay_after_previous_step_unit
      action.send_immediately = data.send_at_kind == 'immediately'

    buildSendAt: (send_at) ->
      parsed_send_at = moment send_at, 'HH:mm'

      if parsed_send_at.isValid()
        parsed_send_at.add(parsed_send_at.utcOffset(), 'minutes')
      else
        null

    dismantleSendAt: (moment_send_at) ->
      return null unless moment_send_at and moment_send_at.isValid and moment_send_at.isValid()
      moment_send_at.clone().subtract(moment_send_at.utcOffset(), 'minutes').format 'HH:mm'

    setFlow: (data) ->
      @flow = data.flow
      @actions = @flow.actions

      if @actions.length == 0
        @addAction(immediately: true)
      else
        @updateCurrentStep()

    updateSendAtPicker: (data) ->
      return unless data.hasOwnProperty 'reference'
      action = @actions[data.reference]

      EventsBus.$emit 'FlowSendAtPicker:Set',
        send_at: @dismantleSendAt @actions[data.reference].send_at || null
        delay_after_previous_step_amount: action.delay_after_previous_step_amount
        delay_after_previous_step_unit: action.delay_after_previous_step_unit
        reference: data.reference
        persisted: action.isPersisted()
        immediately: action.immediately
        undefined_time: action.undefined_time

    updateTypePicker: (data) ->
      return unless data.hasOwnProperty 'reference'
      action = @actions[data.reference]

      EventsBus.$emit 'FlowTypePicker:Set',
        type: action.type
        manual_task_parameters: action.manual_task_parameters
        template_id: action.template_id
        reference: data.reference

    updateCurrentStep: ->
      @current_step = parseInt(Math.max.apply(null, @actions.map (action) -> action.step)) + 1

    getTemplate: (template_id) ->
      @templates.find (template) ->
        template.id == template_id

    loadTemplates: ->
      filters = @mergeCurrentUserFilter(s: 'name asc')
      new TemplatesResource(Session.current_company.id).index @loadTemplatesSuccess, Loader.off, params: {page: 1, per: '10', q: filters}

    loadTemplatesSuccess: (resources) ->
      @templates = resources.templates

    loadTemplateCategories: ->
      new TemplateCategoriesResource(Session.current_company.id)
        .index(@templateCategoriesSuccess, null, params: {q: {s: 'name asc'}})

    templateCategoriesSuccess: (data) ->
      template_category_options = for template_category in data.template_categories
        { value: template_category.id, text: template_category.name }

      template_category_options.unshift( value: null, text: this.$t('flows.label.categorySelect'))

      @template_categories = template_category_options

    loadVariables: ->
      params = { company_id: Session.current_company.id }
      new VariableResource().index(@loadVariablesSuccess, null, {params})

    loadVariablesSuccess: (resource) ->
      @template_variables = resource.variables

  created: ->
    @loadTemplates()
    @loadTemplateCategories()
    @loadVariables()

    EventsBus.$on 'flow-set', @setFlow
    EventsBus.$on 'FlowSendAtPicker:Created', @updateSendAtPicker
    EventsBus.$on 'FlowTypePicker:Created', @updateTypePicker
    EventsBus.$emit 'ActionPicker:Created'

  beforeDestroy: ->
    EventsBus.$off 'flow-set', @setFlow
    EventsBus.$off 'FlowSendAtPicker:Created', @updateSendAtPicker
    EventsBus.$off 'FlowTypePicker:Created', @updateTypePicker
}

exports.default = helpers.vue_include(view_model, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flow_actions/picker.vue